// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__33frz","info":"Note_info__Ghkuq","note":"Note_note__3Y-Vo","actions":"Note_actions__2VS9a"};